<template>
  <modal v-bind="[$props, $attrs]" @modal-close="emitCloseEvent">
    <div class="confirm-header">
      <img v-if="$props.confirmType === 'warning'" src="/assets/images/delete-warning.svg" alt="">
      <img v-if="$props.confirmType === 'success'" src="/assets/images/success.svg" alt="">
      <img v-if="$props.confirmType === 'email'" src="/assets/images/email-confirmation.svg" alt="">
      <h2 class="title">{{ $props.confirmTitle }}</h2>
      <p class="title"
         v-html="$props.dynamicConfirmTitle"></p>
    </div>
    <transition name="fade" mode="out-in">
      <base-inline-loader v-if="$props.loading" :key="'confirm-loader'" height="200"/>
      <div v-else class="confirm-body" :key="'confirm-body'">
        <p class="description">{{ $props.confirmDescription }}</p>
        <p class="description"
           v-html="$props.dynamicDataDescription"></p>
        <slot name="extra-section"></slot>
        <div class="button-container">
          <base-button v-if="$props.confirmButton" variant="primary" @click="emitConfirmEvent" :disabled="$props.buttonDisabled">
            {{ $props.confirmText || $t('common.confirm') }}
          </base-button>
          <base-button v-if="$props.cancelButton" class="cancel-btn" variant="text" @click="emitCloseEvent"
                       :disabled="$props.buttonDisabled">
            {{ $props.cancelText || $t('common.cancel') }}
          </base-button>
        </div>
        <div v-if="$props.bottomLinkDescription" class="bottom-description">
          <hr>
          <span class="small-text">{{ $t('registration.emailConfirmation.linkLabel') }}</span>
        </div>
      </div>
    </transition>
  </modal>
</template>

<script>

import Modal from '@/components/common/modal/modal'

export default {
  name: 'confirmation-modal',
  components: { Modal },
  inheritAttrs: false,
  props: {
    bottomLinkDescription: {
      type: Boolean,
      default: false
    },
    dynamicDataDescription: String,
    dynamicConfirmTitle: String,
    buttonDisabled: Boolean,
    confirmTitle: String,
    confirmDescription: String,
    confirmText: String,
    cancelText: String,
    cancelButton: Boolean,
    confirmButton: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'lg'
    },
    confirmType: {
      type: String,
      default: 'warning',
      validator: value => {
        const allowedTypes = ['warning', 'success', 'email', 'empty']
        return allowedTypes.includes(value)
      }
    },
    loading: Boolean
  },
  methods: {
    emitConfirmEvent () {
      this.$emit('confirm')
    },
    emitCloseEvent () {
      this.$emit('close')
    }
  }
}
</script>

<style scoped lang="scss">
.confirm-header {
  text-align: center;

  img {
    max-width: 80px;
    width: 100%;
    height: auto;
    display: block;
    margin: 0.8rem auto;

    @media (map_get($breakpoints, sm)) {
      max-width: 112px;
    }
  }

  .title {
    font-size: 2.4rem;
    color: $text;
    margin-top: 2.4rem;
    margin-bottom: 1.6rem;
    font-weight: normal;

    @media (map_get($breakpoints, sm)) {
      font-size: 3.2rem;
    }
  }
}

.confirm-body {
  text-align: center;
  max-width: 500px;
  margin: 0 auto;

  .description {
    margin: 4rem 0;
    font-size: 1.4rem;

    @media (map_get($breakpoints, sm)) {
      font-size: 1.6rem;
    }
  }

  .cancel-btn:not(:only-child) {
    margin-left: 0;

    @media (map_get($breakpoints, sm)) {
      margin-left: 4rem;
    }
  }

  .base-button {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: auto;
    }
  }

  .bottom-description {
    margin-top: 4rem;

    .small-text {
      font-size: 1.2rem;
      color: #777777;
    }
  }
}
</style>
